import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";

import axios from "axios";
import qs from "qs";

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$event_hub = new Vue();

Vue.prototype.$NODE_ENV = process.env.NODE_ENV;

Vue.prototype.$information = {
    client_id: process.env.VUE_APP_SPOTIFY_CLIENT_ID,
    client_secret: process.env.VUE_APP_SPOTIFY_CLIENT_SECRET,
    redirect_uri: process.env.VUE_APP_BASE_URL + "/authorize",
    scopes: process.env.VUE_APP_SCOPES.split(",")
};
Vue.prototype.$spotify_credentials = {
    access_token: "",
    refresh_token: "",
    expires_in: ""
};

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount("#app");
